import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {TableExportService} from 'shared/services/table-data-export/table-data-export.service';

import {CockpitCard} from 'shared/dtos/cockpit-card';
import {CockpitKontrolleM2} from 'shared/dtos/cockpit-kontrolle/cockpit-kontrolle';
import {ModellvariantenM2} from 'shared/dtos/cockpit-kontrolle/modellvarianten-m2';
import {DataStorageService} from 'shared/services/data-storage.service';
import {CockpitContentComponent} from '../../../cockpit-shared/cockpit-content-component';
import {MvM2TableKoeffizienteComponent} from './mv-m2-table-koeffiziente/mv-m2-table-koeffiziente.component';
import {MvM2TableResultateComponent} from './mv-m2-table-resultate/mv-m2-table-resultate.component';

@Component({
  selector: 'app-modellvarianten-m2',
  templateUrl: './modellvarianten-m2.component.html',
  styleUrl: './modellvarianten-m2.component.scss',
  standalone: false
})
export class ModellvariantenM2Component
  implements OnInit, CockpitContentComponent
{
  @ViewChild(MvM2TableResultateComponent, {read: ElementRef})
  mvM2TableResultateComponent!: ElementRef;

  @ViewChild(MvM2TableKoeffizienteComponent, {read: ElementRef})
  mvM2TableKoeffizienteComponent!: ElementRef;

  card: CockpitCard;
  data: ModellvariantenM2;

  constructor(
    private readonly storage: DataStorageService,
    private readonly exportService: TableExportService
  ) {}

  async ngOnInit() {
    this.data = (
      (await this.storage.getCockpitKontrolle()) as CockpitKontrolleM2
    ).modellvarianten;
  }

  exportTableResultate() {
    this.exportService.exportHtmlTableInElement(
      this.mvM2TableResultateComponent.nativeElement,
      this.card.title
    );
  }

  exportTableKoeffiziente() {
    this.exportService.exportHtmlTableInElement(
      this.mvM2TableKoeffizienteComponent.nativeElement,
      this.card.title
    );
  }
}
